import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import rootSagas from './sagas'
import reducer from './reducers'
import Firebase from 'firebase'
import Globals from "../Globals";

const app = Firebase.initializeApp(Globals.firebaseConfig);
let store;

export function initializeStore(initialState) {
  const sagaMiddleware = createSagaMiddleware()
  store = createStore(reducer, initialState, applyMiddleware(sagaMiddleware))
  sagaMiddleware.run(rootSagas, app);
  return store;
}

export function returnStore(){
  return store;
}